// Work images
import slmun1 from './assets/images/work/slmun1.jpg';
import recruitx1 from './assets/images/work/recruitx1.jpg';
import slmundb1 from './assets/images/work/slmundb1.jpg';
import senkada from './assets/images/work/senkada.jpg';
import ims1 from './assets/images/work/ims1.jpg';
import white1 from './assets/images/work/white1.jpg';
import vishwa1 from './assets/images/work/vishwa1.jpg';
import yoga from './assets/images/work/yoga.jpg';

// Client images
import emma from './assets/images/clients/emma.png';
import tharaka from './assets/images/clients/tharaka.png';
import chathuranga from './assets/images/clients/chathuranga.png';
import dananjaya from './assets/images/clients/dananjaya.png';
import ellawala from './assets/images/clients/ellawala.png';
import jayantha from './assets/images/clients/jayantha.png';
import anil from './assets/images/clients/anil.jpeg';

export const workData = [
  {
    id: 1,
    image: ims1,
    title: 'Institute Management System',
    client: 'WILLIAM ANGLISS INSTITUTE @ SLIIT',
    description: [
      'This is a complete ERP system we built to manage the entire insitute of William Angliss @ SLIIT. It includes many modules like Stu- dent management, Course management, LMS,\n' +
      'Lecturer management, etc. Since we used the latest technologies for this project, we were able to build a very fast and responsive system. It\'s a great example of how we can use modern technologies to build a great systems.'
    ]
  },
  {
    id: 2,
    image: vishwa1,
    title: 'Vishwarekha',
    client: 'Vishwarekha (Pvt) Ltd',
    description: [
      `<a href="https://vishwarekha.com/en/" target="_blank" rel="noopener noreferrer">
      Vishwarekha</a>’s online marketplace offers
a convenient and easy-to-use platform for customers to explore the authentic flavors of Sri Lanka from the comfort of their own home. With a focus on quality, sustainability, and so- cial responsibility, Vishwarekha is committed to providing a unique and memorable expe- rience for their customers while supporting local communities and farmers in Sri Lanka.
We built this website using WordPress and WooCommerce which are very popular for building e-Commerce websites.`
    ]
  },
  {
    id: 3,
    image: recruitx1,
    title: 'RecruitX Web & Mobile Applications',
    client: 'Client: RecruitX (Pvt) Ltd',
    description: [
      `RecruitX is going to revolutionise the recruitment industry. No CVs and instant
      interviews are the foundations of RecruitX's vision. This is one of the best and the
      most complex applications we built so far. The client's idea is unique. We had
      to overcome many challenges in order to complete this project. For their great
      idea, we wanted to give a long lasting solution. So, as usual, we used the
      latest (But proven) tools and technologies we know to build this app. Mainly,
      it's powered by Meteor and React.`,
      `To give you an idea of how big this app is, imagine... it even got selected to the 2016
       Web Summit! The first startup to achieve such height in Sri Lanka!
       We are really proud to work with this amazing team!`
    ]
  },
  {
    id: 4,
    image: white1,
    title: 'Whiteberry Interiors',
    client: 'Client: Emma Vorwerk',
    description: [
      `<a href="https://whiteberryinteriors.com/" target="_blank" rel="noopener noreferrer">
      Whiteberry Interiors</a> is a boutique interior de- sign consultancy offering a holistic 
      approach to all things “interior”. Specialising in residen- tial interior design and 
      providing a personal one on one approach.`,
      `This website is a hybrid of WordPress and React. At a WordPress developer meetup, we 
      discussed the possibility of merging these two great technologies. So, we did it! 
      Whiteberry Interiors use WordPress in the background to manage the content making things 
      a lot easier for the client to update the website. For the front, it uses React which 
      brings the modern web technologies to this site.`
    ]
  },
  {
    id: 5,
    image: senkada,
    title: 'Senkada Recruitment Consultants',
    client: 'Client: Salaka Senkada',
    description: [
      `<a href="https://senkadarecruitment.lk/" target="_blank" rel="noopener noreferrer">Senkada Recruitment Consultants (Pvt) Ltd
      </a>'s website is a great example of how we can use WordPress to build a great website. A simple but a professional website. Senkada is a leading foreign employment agency dedicated to connecting skilled professionals with international job opportunities in Sri Lanka. They are a licensed recruitment agency with the Sri Lanka Bureau of Foreign Employment (SLBFE).`
    ]
  },
  {
    id: 6,
    image: yoga,
    title: 'Yoga Online',
    client: 'Client: Yoga Online Store',
    description: [
      `<a href="https://yogaonline.lk/" target="_blank" rel="noopener noreferrer">Yoga Online Clothing Store
      </a> is a great example of how we can use WooCommerce to build a efficient e-Commerce applications. The design is very minimal and clean. The customers can easily find what they want and buy them. Yoga Online is a leading online store for a wide range of clothing options for men, women, and children, including dresses, tops, bottoms, outerwear, and accessories in Sri Lanka.`
    ]
  },
  {
    id: 7,
    image: slmundb1,
    title: 'SLMUN Database System',
    client: 'Client: Sri Lanka Model United Nations',
    description: [
      `This is a complete database system built for Sri Lanka Model United Nations. SLMUN is
      the Asia’s largest student-run simulation of the United Nation. It's a platform that
      attracts 1000 to 1250 students, between the ages of 13 and 20 years from all over
      the world. Just like the real UN they discuss and debate about global issues...
      To manage all these students, they had a very primitive database system. We completely
      rebuilt a brand new system for them from scratch and its a huge upgrade for them
      considering what they used before! Now they have been using this system for years and
      we keep making it better every year.`
    ]
  },
  {
    id: 8,
    image: slmun1,
    title: 'SLMUN OFFICIAL WEBSITE',
    client: 'Client: Sri Lanka Model United Nations',
    description: [
      `<a href="https://slmun.org/" target="_blank" rel="noopener noreferrer">
      Sri Lanka Model United Nations (SLMUN)</a> is the national MUN conference and
      Asia's
      largest student run conference. The Inaugural SLMUN held at the BMICH, in 2008,
      involving over 1000 students from around Sri Lanka and abroad, put MUN in a new
      paradigm in Sri Lanka.`,
      `This website is built with Meteor.js and React. At the end of last year, we moved
      from Rails to Meteor. With that, we further tried great JavaScript frameworks
      like React. This is only the beginning. With these new technologies, we are
      planning to do great things!`
    ]
  }
];

export const clientData = [
  {
    id: 1,
    image: emma,
    name: 'Mrs. Emma Vorwerk',
    title: 'Managing Director - Whiteberry Interiors',
    testimonial: [
      `Leafy code created my website for House of Henley a beach house offering boutique
      accommodation in South Australia. The team were very efficient and the whole process
      was very professional. `,
      `The small video tutorials they provide on how to upload images and amend text are very
      useful and make managing the site very easy.`,
      `It was important for us to create a simple, modern and user-friendly website that
       captures our brand and the essence of the home, we were very happy with the end
       result and felt the whole process was managed and executed to our expectations.`
    ]
  },
  {
    id: 2,
    image: anil,
    name: 'Mr. Anil Vaitla',
    title: 'Co-Founder & CTO at NOCD',
    testimonial: [
      `We worked with Leafycode in the early stages of our project. They are an exceptional team. Honest and precise in development, deep understanding of technical details, easy to talk to and a joy to work with. Leafycode built our main website and helped us migrate many things from wordpress to nextjs and improve seo, polish, and lay the groundwork for our code base. Great team!`
    ]
  },
  {
    id: 3,
    image: tharaka,
    name: 'Mr. Tharaka De Alwis',
    title: 'CTO, RecruitX',
    testimonial: [
      `Excellent turn-around time, on-time delivery and exceptional quality. This was our first
       attempt at outsourcing a mobile responsive web application and LeafyCode proved our
       decision right. I am overwhelmed with the great response and support I got from their
       end. Thank you LeafyCode`
    ]
  },
  {
    id: 4,
    image: dananjaya,
    name: 'Mr. Dananjaya Wijesekara',
    title: 'Director - Kahawanu (Pvt) Ltd | ACIM (UK), Dip. In Psychology',
    testimonial: [
      `In the e-commerce industry there are number of web developers , but the choice you make to
      find the best out of the best is quite challengeable. Mr. Pubudu Kodikara is one of the best
      talented web developer I have ever met in my life. Not only the web developing side he will
      assist you in strategic marketing, on line marketing, idea generation etc.`,
      `In the Kahawanu.com most of our initial ideas he always developed with something
      extraordinary, that’s his talent which I think came from his birth. Also his courage,
      dedication and never give up attitudes always give us a new thought and refreshment
      during the developing stage.`,
      `Moreover, you can fully trust on him who is an amazing trustworthy web developer.
      His passion for hard work, creativity and genuineness I have no hesitation in recommending
       him for your ultimate next web-development activity.`,
      `In fact, I have no words for thanking you since you always did something extra for us,
      that we never expected. ‘Pudubu’ you always add something value to our lives, beyond the
      business relationship, whereby you became one of our closest friends in the end. My
      sincere thanks for you on behalf of Kahawanu (Pvt) Ltd.`
    ]
  },
  {
    id: 5,
    image: ellawala,
    name: 'Mr. R L Ellawala',
    title: 'Charge D’ Affairs SLMUN',
    testimonial: [
      `If you want to trust a company for your work whether it is web designing or developing a
       database or any other thing related to software development: LeafyCode should be your
        first choice. Why I should say like his because they know by heart what you want at
        the end and their knowledge and innovative thinking is commendable.`,
      `They designed my two websites and the databases which are so user-friendly and advance.
      It is easy to collect data and information you need in seconds.`,
      `They are honest, trustworthy and a great company with qualities that nobody could expect
      these days. Without any hesitation, I would like to recommend them.`
    ]
  },
  {
    id: 6,
    image: jayantha,
    name: 'Mr. Jayantha Wanniarachchi',
    title: 'Managing Director of Jaya Lanka Tours (Pvt) Ltd',
    testimonial: [
      `Leafy Code was really flexible in developing our website from beginning to the end. They
      understood what we are expecting and had a lot of new creative ideas all the time.`,
      `Most of the time were good with deadlines and was able to publish the website within the
       expected time period.`,
      `We believe that they have done a marvelous job for the value we spent on this project and
       we wish them all the best for their future as professional web developers!`
    ]
  },
  {
    id: 7,
    image: chathuranga,
    name: 'Mr. Chathuranga Bandara Udagama',
    title: 'Founder Dr Cr Hub',
    testimonial: [
      `LeafyCode is one of the top talented web developers that I have ever met.
      I get their service for building my Digital Ocean unmanaged VPS.`,
      `They built my VPS (Ubuntu, Nginx, MySQL, PHP) and installed all the requested
      modules and other necessary mods in several hours.`,
      `They did not just create this LEMP VPS, they also optimised it to use less RAM and
      improve the page loading time. Actually, after their work, I can achieve less than
       2 seconds page loading time (previously it was 5 seconds) and improved First Byte
       Time (FBT). Now my two WordPress sites consume lower RAM, than the previous VPS.`,
      `They are a very friendly company and provide their support quickly, even after
      their service.`,
      `Thank you so much LeafyCode for your support for hosting my WordPress sites in an
      unmanaged VPS.`
    ]
  },

];



// WEBPACK FOOTER //
// ./src/data.js